import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Typography,
  Icon,
  Button,
} from '@material-ui/core';
import { TenantService } from '@pingum/api-services';
import { getTenantFromUrl } from '../../../utils/urlHelper';
import styles from './styles';

const tenantUrl = TenantService.getTenantUrl(getTenantFromUrl());

export const AccessDeniedPageComponent = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.content}>
      <Paper className={classes.root} elevation={10}>
        <Icon className={classes.icon}>
          block
        </Icon>
        <Typography
          variant="h3"
          align="center"
        >
          No Valid Payment Method On File
        </Typography>
        <Typography variant="subtitle1" align="center" gutterBottom>
          This organization is not on a free trial and does not have a valid payment plan or credit card
          applied.
        </Typography>
        <Typography variant="body2" align="center" gutterBottom>
          Please have the owner of the organization subscribe to a payment plan
          and provide a valid credit card if you wish to continue using Pingum.
          <br />
          <strong><a href={tenantUrl}>{tenantUrl}</a></strong>.
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            size="small"
            href="https://pingum.io/contact-us/"
            variant="contained"
          >
            Contact Pingum Support
          </Button>
        </div>
      </Paper>
    </div>
  </div>
);

AccessDeniedPageComponent.propTypes = { classes: PropTypes.object };
AccessDeniedPageComponent.defaultProps = { classes: {} };

export default withStyles(styles, { withTheme: true })(AccessDeniedPageComponent);
